<template>
<div class="grid">
    <Loader v-if="loading" />
    <div class="col-12 lg:col-12 xl:col-12">
        <div class="card" id="printme" ref="printme" v-if="Application.application_id">
        <div class="container Application_container mt-4" >
            <h4><b>Application Details : </b></h4>
            <table class="table table-bordered" style="border: 1px solid black !important;">
                <tbody>
                    <tr>
                        <td><strong>Current Status :</strong> <span class="status-pending">{{capitalizeFirstLetter(Application.application_status_name)}}</span></td>
                        <td><strong>Application ID :</strong><span class="status-pending">{{Application.application_id}}</span> </td>
                        <td><strong>Application For :</strong><span class="highlight">{{capitalizeFirstLetter(Applicationsurvey.Application_Type)}}</span> </td>
                    </tr>
                    <tr>
                        <td><strong>Applicant Name :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Applicant_Prefix) }} {{ capitalizeFirstLetter(Applicationsurvey.Applicant_First_Name) }} {{ capitalizeFirstLetter(Applicationsurvey.Applicant_Middle_Name) }} {{ Applicationsurvey.Applicant_Last_Name }}</span></td>
                        <td colspan="2"><strong>Registration No :</strong> <span class="highlight">{{ Applicationsurvey.Registration_No }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Father Name :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.F_Prefix) }} {{ capitalizeFirstLetter(Applicationsurvey.F_First_Name) }} {{ capitalizeFirstLetter(Applicationsurvey.F_Middle_Name) }} {{ capitalizeFirstLetter(Applicationsurvey.F_Last_Name) }}</span></td>
                        <td><strong>Mother Name :</strong> <span class="highlight">{{ Applicationsurvey.M_Prefix }} {{ Applicationsurvey.M_First_Name }} {{ Applicationsurvey.M_Middle_Name }} {{ Applicationsurvey.M_Last_Name }}</span></td>
                        <td><strong>DOB :</strong> <span class="highlight">{{Applicationsurvey.DOB}}</span></td>
                    </tr>
                    <tr>
                        <td width="40%"><strong>Address Of Applicant :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Present_Address) }}
                        </span></td>
                        <td><strong>Email :</strong> <span class="highlight">{{ Applicationsurvey.Emailid }}
                        </span></td>
                        <td><strong>MobileNo :</strong> <span class="highlight">{{ Applicationsurvey.MobileNO }}
                        </span></td>
                    </tr>
                    <tr>
                        <td colspan="2"><strong>Pincode :</strong> <span class="highlight">{{ Applicationsurvey.Pincode }}</span></td>
                        <!-- <td><strong>GST No :</strong> <span class="highlight">{{ Applicationsurvey.GST }}</span></td> -->
                        <td><strong>Taluka :</strong> <span class="highlight">{{capitalizeFirstLetter(Applicationsurvey.Taluka)}}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Martial Status :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Martial_status) }}</span></td>
                        <td><strong>Nationality:</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Nationality) }}</span></td>
                        <td><strong>Village :</strong> <span class="highlight">{{capitalizeFirstLetter(Applicationsurvey.Village)}}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Permanent Address :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Permanent_Address) }}</span></td>
                        <td><strong>Name of the qualifying examination:</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Name_of_the_qualifying_Examination) }}</span></td>
                        <td><strong>Date passing the qualifying examination :</strong> <span class="highlight">{{Applicationsurvey.Date_passing_the_qualifying_examination}}</span></td>
                    </tr>
                    <tr>
                        <td colspan="2"><strong>Name of the educational institution :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Name_of_the_educational_Institution) }}</span></td>
                        <td><strong>place of the educational institution :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.place_of_the_educational_Institution) }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Name of the regulatory authority :</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.Name_of_the_Regulatory_Authority) }}</span></td>
                        <td><strong>State of the regulatory authority:</strong> <span class="highlight">{{ capitalizeFirstLetter(Applicationsurvey.state_of_the_Regulatory_Authority) }}</span></td>
                        <td><strong>Distinctive number of the regulatory authority :</strong> <span class="highlight">{{Applicationsurvey.Distinctive_Number_of_the_Regulatory_Authority}}</span></td>
                    </tr>
                  
                    
                    
                    <!-- <tr>
                        <td colspan="3">
                            <strong>ज्या जमीनदार/इसमांतिवर आकाशविच प्रदशित करण्याचे प्रस्तावित आहे त्या जमीनिच्या/इसमांतिवे मालकांकडून घेतलेले ना हरकत प्रमाणपत्र :</strong> <span class="highlight">Yes</span><br />
                            <strong>ना हरकत प्रमाणपत्र :</strong> <a href="#" class="yes-upload">xxxxxxxxxxxx.pdf</a><br />
                            <strong>प्रॉपर्टी कार्ड :</strong> <a href="#" class="yes-upload">xxxxxxx.pdf</a>
                        </td>
                    </tr> -->
                </tbody>
            </table>
        </div>
        
        <div class="container Document_container mt-4">
            <h4><b>Document Details : </b></h4>
            <div class="p-fluid formgrid grid" style="margin-top: 1%">
                <div class="field col-4 md:col-4">
                    <table class="table table-bordered" style="border: 1px solid black !important;">
                        <tbody>
                            
                            <tr>
                                <td colspan="4"><strong>1) Identity Proof :</strong> <span v-if="Applicationsurvey['Identity_Proof_Doc']" class="highlight">{{ Applicationsurvey['Identity_Proof_Doc'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Identity_Proof_Doc']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Identity_Proof_Doc'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>2) photo :</strong> <span v-if="Applicationsurvey['photo']" class="highlight">{{ Applicationsurvey['photo'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['photo']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['photo'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>3) signature :</strong> <span v-if="Applicationsurvey['signature']" class="highlight">{{ Applicationsurvey['signature'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['signature']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['signature'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>4) DOB Doc :</strong> <span v-if="Applicationsurvey['DOB_Doc']" class="highlight">{{ Applicationsurvey['DOB_Doc'][0]['name'] }}</span></td>
                                <td>
                                
                                    <Button v-if="Applicationsurvey['DOB_Doc']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['DOB_Doc'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>5) Certificate of provisional registration :</strong> <span v-if="Applicationsurvey['Certificate_of_Provisional_Registration.']" class="highlight">{{ Applicationsurvey['Certificate_of_Provisional_Registration.'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Certificate_of_Provisional_Registration.']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Certificate_of_Provisional_Registration.'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>6) Certificate satisfactory completion :</strong> <span v-if="Applicationsurvey['Certificate_satisfactory_completion.']" class="highlight">{{ Applicationsurvey['Certificate_satisfactory_completion.'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Certificate_satisfactory_completion.']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Certificate_satisfactory_completion.'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>7) Proof of charge of name:</strong> <span v-if="Applicationsurvey['Proof_of_charge_of_name.']" class="highlight">{{ Applicationsurvey['Proof_of_charge_of_name.'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Proof_of_charge_of_name.']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Proof_of_charge_of_name.'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>8) NOC :</strong> <span v-if="Applicationsurvey['NOC.']" class="highlight">{{ Applicationsurvey['NOC.'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['NOC.']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['NOC.'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>9) Purpose copy of registration in Maharashtra :</strong> <span v-if="Applicationsurvey['Purpose_Copy_of_Registration_in_Maharashtra']" class="highlight">{{ Applicationsurvey['Purpose_Copy_of_Registration_in_Maharashtra'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Purpose_Copy_of_Registration_in_Maharashtra']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Purpose_Copy_of_Registration_in_Maharashtra'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>9) Certificate of having passed qualifying examination :</strong> <span v-if="Applicationsurvey['Certificate_of_having_passed_qualifying_examination']" class="highlight">{{ Applicationsurvey['Certificate_of_having_passed_qualifying_examination'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Certificate_of_having_passed_qualifying_examination']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Certificate_of_having_passed_qualifying_examination'][0]['content'])" />
                                </td>
                            </tr>
                            
                   
                        </tbody>
                    </table>
                </div>
                <div class="field col-8 md:col-8">
                    <iframe :src="`${file}#zoom=50`" style="width: 100%;height: 100%;border: none;" frameborder="0"></iframe>
                </div>
            </div>
        </div>
        </div>
        <!-- <div class="card">
            <div class="container-fluid" style="background-color: #e8f0f3">
                <div class="application-view" style="height: 500px;overflow: scroll;">
                    <div class="reg-form-box">
                        <div class="reg-form-body">

                            <div class="mb-3" v-for="(page, index) in applicationTemplate.pages" :key="index" style=" padding: 10px; color: blueviolet; width: 100%;">
                                <h6><b>{{ page.title }}</b></h6>
                                <div class="grid">
                                    <div class="col-12">
                                        <div class="grid" v-for="(element, ix) in page.elements" :key="ix" style="margin-top: 0px !important;">
                                            <div class="col-2" style="border: 0.1px solid rgb(199, 189, 189);color: rgb(8, 7, 7);" v-if="element.type != 'matrixdropdown'">
                                                <p>{{ element.title }}</p>
                                            </div>
                                            <div class="col-10" style="border: 0.1px solid rgb(197, 194, 194); color: rgb(115, 116, 117); font-size: 10px;" v-if="element.type != 'matrixdropdown'">
                                                <button v-if="element.type == 'file'" type="link" class="btn btn-warning" @click="view(element)">
                                                    view
                                                </button>
                                                <div v-if="element.type == 'paneldynamic'">

                                                    <DataTable :value="Applicationsurvey[element.name]">
                                                        <Column header="No">
                                                            <template #body="{ index }">
                                                                <span>{{ +index + +1 }}</span>

                                                            </template>
                                                        </Column>
                                                        <Column field="HoardingName" header="HoardingName">
                                                            <template #body="{ data }">
                                                                <span>{{ data.HoardingName }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="OwnerName" header="Owner Name">
                                                            <template #body="{ data }">
                                                                <span>{{ data.OwnerName }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="HoardingType" header="Type">
                                                            <template #body="{ data }">
                                                                <span>{{ data.HoardingType }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="Height" header="H x W">
                                                            <template #body="{ data }">
                                                                <span>{{ data.Height }} x {{ data.width }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="HoardingAddress" header="Address">
                                                                                            <template #body="{ data }">
                                                                                                <span>{{ data.HoardingAddress }}</span>
                                                                                            </template>
                                                                                        </Column>
                                                        <Column field="Documents" header="Docs">
                                                            <template #body="{ data }">
                                                                <Button icon="pi pi-book" @click="documentshow(data['Hoarding image'])" v-tooltip.bottom="'View Documents'" />
                                                                                                &nbsp;
                                                                                                <Button icon="pi pi-book" @click="documentshow(data['Undertaking'])" v-tooltip.bottom="'View Documents'" />
                                                                                                &nbsp;
                                                                                                <Button icon="pi pi-book" @click="documentshow(data['Permit certificate'])" v-tooltip.bottom="'View Documents'" />
                                                            </template>
                                                        </Column>
                                                        

                                                    </DataTable>
                                                </div>
                                                <h6 v-else>{{ Applicationsurvey[element.name] }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="card" v-if="App_LogHistory.length>0">
            <b>Application Log History :</b>
            <Divider />
            <table class="table" style="border: 1px solid black !important;width: 100%;">
                <tbody>
                    <tr v-for="(row, index) in App_LogHistory" :key="index">
                        <td><strong>Application Status :</strong> <span class="status-pending">{{row.StatusName?row.StatusName:'-'}}</span></td>
                        <td><strong>Approve/Reject Date :</strong> {{dateFormatDMY(row.CreatedDate)}}</td>
                        <td><strong>Remarks:</strong> 
                            <span class="Remarks">{{row.RejectRemarks?row.RejectRemarks:'-'}}</span>
                        </td>
                        <td v-if="row.RejectionReason"><strong>Rejection Reason :</strong><span class="reject_reason">{{row.RejectionReason?row.RejectionReason:'-'}}</span> </td>
                    </tr>
                    
                </tbody>
            </table>
        
        </div>
        
    </div>

    <div class="col-12 lg:col-12 xl:col-12">
        <div class="card" v-if="isApprovalAccess==true">
            <b>Application Approval :</b>
            <Divider />
            <div class="m-0">
                <div class="p-fluid formgrid grid">

                    <div class="field col-12 md:col-3" style="margin-top: 10px;">
                        <span class="p-float-label">
                            <Dropdown id="status" value-field="StatusID" v-model="Approve_selectstatus" :options="Approve_dropdownItems" :value="Approve_dropdownItems.StatusID" optionLabel="Status" @change.native="checkReject" required="true">
                            </Dropdown>
                            <label for="status">Approve Application</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 10px;" v-if="this.show">
                        <span class="p-float-label">
                            <Dropdown id="status" v-model="Reject_selectstatus" :options="Reject_dropdownItems" :value="Reject_dropdownItems.RejectionReasonID" optionLabel="RejectionReason" required="true"></Dropdown>
                            <label for="status">Reject Reason</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 10px;">
                        <Button icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" class="mr-2" />
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 10px;"></div>

                    <div class="field col-12 md:col-12" style="margin-top: 10px;">
                        <span class="p-float-label">
                            <Textarea inputId="textarea" rows="4" cols="30" v-model="product.remark"></Textarea>
                            <label for="topic">Remark</label>
                        </span>
                    </div>
                </div>
            </div>

            <div class="m-0" style="text-align: center">
                <Button label="Primary" class="p-button-success p-button-Raised mr-2 mb-2" @click="Application_Approval">Submit</Button>
                <Button label="Primary" class="p-button-danger p-button-Raised mr-2 mb-2" @click="cancel">Back</Button>
            </div>

        </div>
    </div>

    <Dialog :v-model:visible="productdoc" modal :header="hoarding_title" :style="{ width: '60rem' }">
        <DataTable :value="doc">
            <Column header="No">
                <template #body="{ index }">
                    <span>{{ +index + +1 }}</span>

                </template>
            </Column>
            <Column field="HoardingName" header="Document">
                <template #body="{ data }">
                    <span>{{ data.name }}</span>
                </template>
            </Column>

            <Column field="Documents" header="Docs">
                <template #body="{ data }">
                    <Button icon="pi pi-eye" @click="viewdoc(data)" v-tooltip.bottom="'View Documents'" />

                </template>
            </Column>
        </DataTable>
    </Dialog>

</div>
</template>

<script>
import apis from "@/apis";
import axios from "axios";
import Loader from "../components/Loader.vue";
export default {
    name: "EdukattaGovermentAdminUIApplicationApproval",
    components: {
Loader	},
    data() {
        return {
            loading:false,
            isApprovalAccess: false,
            user_roll_id: "",
            hoarding_title: '',
            doc: [],
            productdoc: false,
            applicationTemplate: '',
            ApplicationDetails: "",
            Applicationsurvey: [],
            App_LogHistory: [],
            App_ReadRejectReason: [],
            App_RoleStatusMappingByAppStatus: [],
            product: {},
            Reject_selectstatus: null,
            Reject_dropdownItems: [],
            Approve_selectstatus: null,
            Approve_dropdownItems: [],
            show: false,
            file:'',
            Application:[],
            userDetails:[],
        };
    },
    async mounted() {
        var approval_flag = "";
        if (localStorage.getItem("flag")) {
            approval_flag = localStorage.getItem("flag");
        }

        if (localStorage.getItem("applicationdata")) {
            this.ApplicationDetails = await JSON.parse(
                localStorage.getItem("applicationdata")
            );
            if (localStorage.getItem("surveydata")) {
                var temp = [];
                var survey = JSON.parse(localStorage.getItem("surveydata"));
                temp.push(JSON.parse(survey));
                //this.Applicationsurvey = temp[0];
            }

            localStorage.setItem("applicationdata", "");
            localStorage.setItem("surveydata", "");
            localStorage.setItem("flag", "");
        } else {
            this.$toast.add({
                severity: "error",
                summary: "Error!!!",
                detail: "Data Not Found",
                life: 3000,
            });
            this.$router.push({
                name: "ApplicationList"
            });
            return false;
        }

        if (approval_flag == 1) {
            await this.approval_access();
        }   
            await this.GET_getApplicationDetailsbyID();
            await this.Get_ApplicationTemplate();
            await this.Get_ApplicationLogHistory();
            await this.Get_ReadRejectReason();
            await this.Get_RoleStatusMappingByAppStatus();
    },
    methods: {
        capitalizeFirstLetter(str) {
        if (!str) return ''; // check if the string is empty or null
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
        ViewDOC(path)
        {       this.file = path;
                //window.open(path);
        },
        async GET_getApplicationDetailsbyID() {
            var application_id = this.ApplicationDetails["application_id"];
            var data = {
                application_id: application_id,
            };
            this.loading = true;
            var promise = apis.getApplicationDetailsbyID(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.status==true) {
                    this.Applicationsurvey = JSON.parse(response.data.data[0]['application_details']);
                    this.Application = response.data.data[0];
                    if (response.data.user_details.length>0) {
                      this.userDetails = response.data.user_details[0];
                    }
                }
                
            });
        },
        dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return date + "-" + month + "-" + year;
          }
        }
      }
      else {
        return "";
      }
    },
        async approval_access() {
            var data = {
                role_id: localStorage.getItem("user_role_id"),
                application_status: this.ApplicationDetails.application_status,
            };
            this.loading = true;
            var promise = apis.ApprovalAccess(data);
            promise.then((response) => {
                this.loading = false;
                this.isApprovalAccess = response.data.isApprovalAccess;
                
            });
            
        },



        async documentshow(doc) {
            window.open(doc[0]['content']);
        },
        async showdocs(data) {
            console.log(data);
            
            this.hoarding_title = data.HoardingName;
            this.doc = data.document;
            this.productdoc = true;
        },
        async viewdoc(data) {
            window.open(data.content)
        },
        checkReject(evt) {
            if (this.Approve_selectstatus.IsReject == 1) {
                this.show = true;
            } else {
                this.Reject_selectstatus = null;
                this.show = false;
            }
        },
        reset() {
            this.Approve_selectstatus = null;
            this.Reject_selectstatus = null;
            this.product.remark = '';
            this.show = false;
        },
        formatApplicationData(applicationData) {
            // Convert application_details back to JSON object
            const details = JSON.parse(applicationData.application_details);
            // Format application_details object
            const formattedDetails = JSON.stringify(details, null, 2);
            // Create a new object without application_details
            const newData = {
                ...applicationData
            };
            delete newData.application_details;
            // Combine formatted application_details with the rest of the data
            const formattedData = {
                ...newData,
                application_details: formattedDetails,
            };
            // Convert the combined object to a formatted JSON string
            const formattedString = JSON.stringify(formattedData, null, 2);
            return formattedString;
        },
        cancel() {
            this.$router.push({
                name: "ApplicationList"
            });
        },
           //Date format
           D_M_Y_formatDate(date_parm) {
            if (date_parm) {
                let date = new Date(date_parm);
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = dd + '-' + mm + '-' + yyyy;
                // alert(dd)
                if (dd.toString() != 'NaN') {
                    //this.receipt_new_date = new_date;
                    return new_date;
                } else {
                    return date_parm;
                }
            }
        },
        //LOG
        async Application_Approval() {
            var application_id = this.ApplicationDetails["application_id"];
            var application_status = this.Approve_selectstatus.StatusID;
            var RejectReason = "";
            if (
                this.Reject_selectstatus ||
                this.Reject_selectstatus != undefined ||
                this.Reject_selectstatus != null
            ) {
                RejectReason = this.Reject_selectstatus.RejectionReasonID;
            }
            var RejectionRemarks = "";
            if (this.product.remark) {
                RejectionRemarks = this.product.remark;
            }
            var CreatedUser = localStorage.getItem("id");
            var data = {
                application_id: application_id,
                application_id: application_id,
                application_status: application_status ? application_status.toString() : '',
                RejectReason: RejectReason ? RejectReason.toString() : '',
                RejectionRemarks: RejectionRemarks,
                CreatedUser: "8E0245AD-D2FE-400F-9E0F-16651815998F",
            };
            this.loading = true;
            var promise = apis.ApplicationApproval(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.status == true) {
                    this.$swal(response.data.message);
                    this.$router.go(-1);
                } else {
                    this.$swal(response.data.message);
                }
            });
        },
        //LOG
        async Get_ApplicationLogHistory() {
            var application_id = this.ApplicationDetails["application_id"];
            var data = {
                application_id: application_id,
            };
            this.loading = true;
            var promise = apis.ApplicationLogHistory(data);
            promise.then((response) => {
                this.loading = false;
                this.App_LogHistory = response.data.data;
            });
        },
        //REJECT REASON
        async Get_ReadRejectReason() {
            var data = {};
            this.loading = true;
            var promise = apis.ReadRejectReason(data);
            promise.then((response) => {
                this.loading = false;
                this.Reject_dropdownItems = response.data.data;
            });
        },
        //GET STATUS
        async Get_RoleStatusMappingByAppStatus() {
            var data = {
                RoleID: localStorage.getItem("user_role_id"),
                ApplicationStatus: this.ApplicationDetails.application_status,
            };
            this.loading = true;
            var promise = apis.RoleStatusMappingByAppStatus(data);
            promise.then((response) => {
                this.loading = false;
                this.Approve_dropdownItems = response.data.data;
            });
        },
        //application template
        async Get_ApplicationTemplate() {
            var data = {
                "scheme_id": "123E4567-E89B-12D3-A456-426614174003"
            };

            var promise = apis.GetApplicationTemp(data);
            promise.then((response) => {

                this.applicationTemplate = JSON.parse(response.data.data[0]['application_template']);
            });
        },
        print() {
            window.print();
            //this.$htmlToPaper("printme");
        },
    },
};
</script>

<style>
.p-main-container {
    padding-top: 30px;
    background-color: #fff;
    padding-bottom: 30px;
}

.p-buttons-wrap {
    width: fit-content;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
}

table.b {
    table-layout: fixed;
    width: 500px;
}

.p-buttons-wrap button {
    color: #fff;
    background-color: #2e4b90;
    font-size: 13px;
    font-weight: bold;
    border: none;
    padding: 8px 20px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 4px;
}

.p-buttons-wrap button.btn-info:hover,
.p-buttons-wrap button.btn-info:active,
.p-buttons-wrap button.btn-info:visited,
.p-buttons-wrap button.btn-info:focus {
    background-color: #2e4b90 !important;
    color: #fff !important;
    border: none !important;
    outline: none !important;
}

.text-primary {
    font-size: 18px;
    color: #000 !important;
    margin-bottom: 20px;
    font-weight: bold;
}

table.profile-table {
    border: 0px solid #d3d3d3;
    width: 100%;
    text-align: left;
    border-collapse: collapse;
}

table.profile-table td,
table.profile-table th {
    border: 1px solid #d3d3d3;
    padding: 8px 15px;
}

table.table-3x td,
table.table-3x th {
    width: 33%;
}

table.profile-table td span.bold {
    font-weight: bold;
    font-size: 14px;
}

.bold {
    font-weight: bold;
    font-size: 14;
    color: #000;
}

table.profile-table tbody td {
    font-size: 13px;
    color: #000000;
}

table.doc-table {
    width: 10%;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
.table tr {
    height: 10px; /* Adjust the height as needed */
  }
  .table td {
    padding: 5px 10px; /* Increase padding for more spacing */
  }

/* .reg-form-box .reg-form-body {
  border: none;
  padding-top: 10px;
  padding-bottom: 0;
} */

.status-pending {
    color: purple;
    font-weight: bold;
}
.highlight {
    color: green;
    font-weight: bold;
}
.Remarks {
    color: green;
    font-weight: bold;
}
.no-upload {
    color: red;
}
.reject_reason {
    color: red;
}
.yes-upload {
    color: blue;
}
</style>
